import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class PriceBookRuleQueryCriteriaClass extends BaseCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  price_book_hdr_guid?: Optional<string> = Optional.empty();
  price_book_line_guid?: Optional<string> = Optional.empty();
  rule_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<string> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
}

export class PriceBookRuleCriteriaModelQuery {
  query = '';

  constructor(priceBookRulelCriteriaModel: PriceBookRuleQueryCriteriaClass) {

    if (!priceBookRulelCriteriaModel) {
      return;
    }

    // this.query += LabelQueryCriteriaClass.convertOptionalStringToQueryParms(labelCriteriaModel.guid_parent, 'guid_parent' );
    this.query += priceBookRulelCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.price_book_hdr_guid.filter(x => x !== '').map(x => '&price_book_hdr_guid=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.price_book_line_guid.filter(x => x !== '').map(x => '&price_book_line_guid=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.rule_type.filter(x => x !== '').map(x => '&rule_type=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += priceBookRulelCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += priceBookRulelCriteriaModel.value_numeric.filter(x => x !== '').map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + priceBookRulelCriteriaModel.status;
    this.query += '&orderBy=' + priceBookRulelCriteriaModel.orderBy;
    this.query += '&order=' + priceBookRulelCriteriaModel.order;
    this.query += '&offset=' + priceBookRulelCriteriaModel.offset + '&limit=' + priceBookRulelCriteriaModel.limit;
  }
}
